<template>
<el-container style="height: 100%; border: 1px solid #eee;">
  <el-header style="font-size: 20px">
    <el-row>
      <el-col style="text-align: center; width: 90%;">
        <span>Visual Metaphor in Data Visualization</span>
      </el-col>
      <el-col style="text-align: right; width: 10%;">
        <el-popover
          style="text-align: right"
          placement="bottom"
          width="600"
          trigger="click">
          <el-table :data="statTable" :row-class-name="tableRowClassName"
          @cell-dblclick="handleTableDblclick">
            <el-table-column v-for="col of columns" :key="col" :width="col===columns[0]?200:50" :property="col" :label="col"></el-table-column>
          </el-table>
          <el-button slot="reference" @click="getStat">统计</el-button>
        </el-popover>
      </el-col>
    </el-row>
  </el-header>
  
  
  <el-container style="overflow: hidden;">
    <el-aside width="15%" style="background-color: rgb(238, 241, 246); padding: 30px;">
      <div v-for="dim in rootKeys" :key="dim">
        <div>{{ rootNames[dim] }}</div>
        <el-cascader :options="dim in space?space[dim]:[]" :show-all-levels="false" clearable filterable
        :props="{ multiple: true }" @change="(v)=>handleChange(v, dim)" style="margin-top: 10px; margin-bottom: 30px; width: 90%;">
          <template slot-scope="{ node, data }">
            <span>{{ data.label }}</span>
            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
          </template>
        </el-cascader>
      </div>
      <div>
        <el-button type="warning" @click="filterFlags" style="margin-top: 10px;">筛选标记</el-button>
        <el-button type="danger" @click="filterUnAnno" style="margin-top: 10px;">筛未标注</el-button>
      </div>
      <el-button type="info" @click="updateCards" style="margin-top: 10px;">显示选择</el-button>
    </el-aside>
    <el-main style="overflow: hidden; padding: 0px;">
      <el-col style="height: 100%;">
        <el-row style="height: 60px; background-color: rgb(238, 241, 246);">
          <div style="padding-left: 15px;">
            <h1>Count: {{ showCount }}; Labeled: {{ labelCount }}; Flagged: {{ flagCount }}</h1>
          </div>
        </el-row>
        <el-row style="overflow-y: auto; height: calc(100% - 60px); padding-left: 20px;">
          <el-card v-for="card in allCards" :key="card.name" :body-style="{ padding: '10px' }" shadow="hover"
          style="margin: 10px; width: 200px; height: 400px; border-width: 5px;" :style="{ display: card.show ? 'inline-block' : 'none' }"
          :class='{ flagged: flags.includes(card.name), diff: card.design["What"][0].length===0 }'>  
          <!-- diff: card.design["What-yukai"][0]!==card.design["What-jiashu"][0],  -->
            <!-- <div style="margin-bottom: 5px;" :title="card.name"> {{card.name.length > 15 ? card.name.substring(0, 15)+'...' : card.name}}</div> -->
            <div style="margin-bottom: 5px; word-break: break-all; overflow-y: auto; height: 20px;" :title="card.name"> {{card.name}}</div>
            <el-image :src="imageUrl(card.name, 1)" :preview-src-list="[imageUrl(card.name)]"
            fit="cover" style="width: 100%; height: 200px" lazy>
            <!-- lazy -->
              <div slot="placeholder" class="image-slot">
                Loading<span class="dot">...</span>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <el-button type="warning" icon="el-icon-refresh-right" circle @click="handleDelete(card.name)"></el-button>
            <div style="padding-top: 10px; cursor: pointer; height: 100px; overflow: auto;" @click="handleClickCard(card.name)">
              <div v-for="dim in rootKeys" :key="dim" style="line-height: 20px;">
                <span>{{ dim }}: {{ String(card.design[dim]).replaceAll(',', ', ') }}</span>
              </div>
              <div style="line-height: 20px;">
                <span>Source: {{ card.design['source'] }}</span>
              </div>
              <div class="bottom clearfix">
                <!-- <time class="time">{{ currentDate }}</time> -->
                <!-- <el-button type="text" class="button">操作按钮</el-button> -->
              </div>
            </div>
          </el-card>
        </el-row>
      </el-col>
    </el-main>
  </el-container>

  <!-- 删除前确认 -->
  <el-dialog
    title="提示"
    :visible.sync="deleteDialogVisible"
    width="30%">
    <span>确认要恢复 {{ deleteName }} 吗？</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="deleteDialogVisible = false">取 消</el-button>
      <el-button type="warning" @click="doDelete">确 定</el-button>
    </span>
  </el-dialog>

  <!-- 标注设计空间等信息 -->
  <el-dialog
    title="修改标注"
    :visible.sync="editVisible"
    width="40%" style="line-height: 20px;">
    <el-image :src="editImageUrl" :preview-src-list="[editImageUrl]"
    fit="cover" style="width: 100%; height: 300px">
      <div slot="placeholder" class="image-slot">
        Loading<span class="dot">...</span>
      </div>
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <div>
      <el-input v-model="editInput" type="textarea" :rows="20"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveEdit">保存解释</el-button>
      <el-button @click="editVisible = false">关 闭</el-button>
    </span>
  </el-dialog>

  <!-- 查看详细信息 -->
  <el-dialog
    title="详细信息"
    :visible.sync="dialogVisible"
    width="40%" style="line-height: 20px;">
    <el-button type="warning" @click="setFlag(1)">标 记</el-button>
    <el-button type="info" @click="setFlag(0)">去除标记</el-button>
    <div style="padding: 20px;">{{ dialogInfo.name }}</div>
    <el-image :src="dialogInfo.url" :preview-src-list="[dialogInfo.url]"
    fit="contain" style="width: 100%; padding: 10px;">
      <div slot="placeholder" class="image-slot">
        Loading<span class="dot">...</span>
      </div>
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <div style="padding-top: 20px;">
      <div v-for="dim in rootKeys" :key="dim">
        <span>{{ dim }}: {{ dialogInfo.coding===undefined?'':String(dialogInfo.coding[dim]).replaceAll(',', ', ') }}</span>
      </div>
    </div>
    <div style="padding-top: 20px;">
      <span> 解释 </span>
      <div v-for="user in Object.keys(dialogInfo.anno)" :key="user">
        <span>{{ user }}: {{ String(dialogInfo.anno[user])}}</span><br>
      </div>
    </div>
    <div style="margin: 20px 0;"></div>
    <div>
      <el-input v-model="user" placeholder="请输入你的名字（留空为匿名）" @input="searchAnno"></el-input>
      <div style="margin: 20px 0;"></div>
      <el-input v-model="annoInput" type="textarea" :rows="4" placeholder="请输入解释内容"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveAnno">保存解释</el-button>
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>

</el-container>
</template>

<style>
  .el-header {
    background-color: #d7dee7;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

  .flagged {
    /* background-color: rgb(234, 231, 169); */
    border-color: rgb(234, 231, 169);
    /* border-width: 5px; */
  }

  .diff {
    background-color: rgb(248, 146, 146);
    /* border-color: rgb(248, 146, 146);
    border-width: 5px; */
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>

<script>
import axios from 'axios';
  export default {
    data() {
      const rootNames = {
        // 'What-yukai': 'What (隐喻的本体by yukai)',
        // 'What-jiashu': 'What (隐喻的本体by jiashu)',
        'Why': 'Why (隐喻的目的)',
        'What': 'What (隐喻的本体，数据语义)',
        'How': 'How (隐喻的映射方式)',
        // 'How': 'How (隐喻的映射方式by yukai)',
        // 'How-jiashu': 'How (隐喻的映射方式by jiashu)',
        // 'How-liduan': 'How (隐喻的映射方式by liduan)',
        // 'How-lizhen': 'How (隐喻的映射方式by lizhen)',
        // 'How1': 'How1 (隐喻的内部关联模式)',
        // 'How2': 'How2 (隐喻的视觉设计模式)',
      }
      return {
        flags: [],
        allCards: [],
        coding: {},
        space: {},
        rootNames: rootNames,
        rootKeys: Object.keys(rootNames),
        select: {},
        dialogVisible: false,
        editVisible: false,
        editImageUrl: '',
        dialogInfo: {
          anno: {},
        },
        user: '',
        annoInput: '',
        editInput: '',
        editName: '',
        statTable: [],
        columns: [],
        deleteDialogVisible: false,
        deleteName: '',
      }
    },
    computed: {
      showCount() {
        return this.allCards.filter(card => card.show).length;
      },
      labelCount() {
        return this.allCards.filter(card => card.show && card.design['What'][0].length > 0).length;
      },
      flagCount() {
        return this.allCards.filter(card => card.show && this.flags.includes(card.name)).length;
      },
    },
    methods: {
      updateCards() {
        for (const card of this.allCards) {
          let fir = true;
          let recList = [];
          for (const dim in this.select) {
            if (this.select[dim].length > 0) {
              let find = [];
              for (const v of this.select[dim]) {
                for (const di in card.design[dim]) {
                  if (card.design[dim][di] === this.catNames[v]) {
                    if (fir || recList.includes(di)) {
                      find.push(di);
                    }
                  }
                }
              }
              fir = false;
              recList = find;
            }
          }
          if (recList.length > 0 || fir) {
            card.show = true;
          } else {
            card.show = false;
          }
        }
      },
      handleChange(value, dim) {
        // console.log(value, dim);
        this.select[dim] = value.map(v => v[v.length - 1]);
        // console.log(this.select);
        this.updateCards();
      },
      imageUrl(name, thumb=0) {
        return '/api/image?name=' + name + (thumb ? '&thumb=1' : '');
      },
      // click card show detail
      handleClickCard(name) {
        console.log(name);
        const that = this;
        axios.post('/api/imageinfo', {name: name}).then(function(response) {
          console.log(response.data);
          that.dialogInfo = {
            name: name,
            url: that.imageUrl(name),
            coding: response.data.coding,
            anno: response.data.anno,
          };
          if (that.user in that.dialogInfo.anno) {
            that.annoInput = that.dialogInfo.anno[that.user];
          } else {
            that.annoInput = '';
          }
          that.dialogVisible = true;
        });
      },
      // annotate images
      saveAnno() {
        const that = this;
        if (that.annoInput === '') {
          return;
        }
        axios.post('/api/imageanno', {
          name: that.dialogInfo.name,
          user: that.user,
          anno: that.annoInput,
        }).then(function(response) {
          // console.log(response.data);
          that.dialogInfo.anno = response.data;
        });
      },
      searchAnno() {
        const that = this;
        if ((that.user in that.dialogInfo.anno) && that.annoInput === '') {
          that.annoInput = that.dialogInfo.anno[that.user];
        }
      },
      // set flag
      setFlag(flag) {
        const that = this;
        axios.post('/api/imageflag', {
          name: that.dialogInfo.name,
          flag: flag,
        }).then(function(response) {
          // console.log(response.data);
          that.flags = response.data.flags;
          that.$message({
              message: flag===1?'标记成功':'去除标记成功',
              type: 'success',
              duration: 3000,
          });
        });
      },
      // edit card
      handleCardEdit(name) {
        this.editInput = JSON.stringify(this.coding[name], null, 2);
        this.editVisible = true;
        this.editImageUrl = this.imageUrl(name);
        this.editName = name;
      },
      saveEdit() {
        const that = this;
        axios.post('/api/codingedit', {
          name: that.editName,
          coding: JSON.parse(that.editInput),
        }).then(function(response) {
          if (response.data.success) {
            that.$message({
                message: '修改成功',
                type: 'success',
                duration: 3000,
            });
            that.coding[that.editName] = JSON.parse(that.editInput);
            for (const card of that.allCards) {
              if (card.name === that.editName) {
                card.design = JSON.parse(that.editInput);
                break;
              }
            }
            that.editVisible = false;
          } else {
            that.$message({
                message: '修改失败: ' + response.data.message,
                type: 'error',
                duration: 3000,
            });
          }
        });
      },
      getStat() {
        const that = this;
        axios.post('/api/table', {}).then(function(response) {
          // console.log(response.data);
          that.statTable = response.data.table;
          that.columns = response.data.columns;
        });
      },
      tableRowClassName({row, rowIndex}) {
        row.index = rowIndex;
        if (row[this.columns[0]].startsWith('Why')) {
          return 'success-row';
        }
        return '';
      },
      handleTableDblclick(row, column) {
        if (row[this.columns[0]].startsWith('Why')) return;
        // TODO: hard code here...
        let why_name = '';
        for (const rr in this.statTable) {
          if (rr == row.index) break;
          if (this.statTable[rr][this.columns[0]].startsWith('Why')) {
            let i1 = this.statTable[rr][this.columns[0]].indexOf(' ')+1;
            let i2 = this.statTable[rr][this.columns[0]].indexOf(' ', i1);
            why_name = this.statTable[rr][this.columns[0]].substring(i1, i2);
          }
        }
        let i1 = row[this.columns[0]].indexOf(' ')+1;
        let i2 = row[this.columns[0]].indexOf(' ', i1);
        let what_name = row[this.columns[0]].substring(i1, i2);
        let how_name = column.label;
        this.$message({
          message: `double click ${why_name} ${what_name} ${how_name}`,
          type: 'info',
          duration: 3000,
        });
        // BUG: exist mismatches when multiple codings cooccur
        // this.select = {
        //   'Why': [this.catNames.indexOf(why_name)],
        //   'What': [this.catNames.indexOf(what_name)],
        //   'How': [this.catNames.indexOf(how_name)],
        // };
        // this.updateCards();
        for (const card of this.allCards) {
          const l = card.design['Why'].length;
          card.show = false;
          for (let i = 0; i < l; i++) {
            if (card.design['Why'][i] === why_name &&
                card.design['What'][i] === what_name &&
                card.design['How'][i] === how_name) {
              card.show = true;
              break;
            }
          }
        }
      },
      handleDelete(name) {
        this.deleteName = name;
        this.deleteDialogVisible = true;
      },
      doDelete() {
        const that = this;
        axios.post('/api/imagerestore', {name: that.deleteName}).then(function(response) {
          if (response.data.success) {
            that.$message({
                message: '恢复成功',
                type: 'success',
                duration: 3000,
            });
            that.allCards = that.allCards.filter(card => card.name !== that.deleteName);
          } else {
            that.$message({
                message: '恢复失败: ' + response.data.message,
                type: 'error',
                duration: 3000,
            });
          }
          that.deleteDialogVisible = false;
          that.deleteName = '';
        });
      },
      filterFlags() {
        for (const card of this.allCards) {
          if (card.show) {
            card.show = this.flags.includes(card.name);
          }
        }
      },
      filterUnAnno() {
        for (const card of this.allCards) {
          if (card.show) {
            card.show = card.design['What'][0].length === 0;
          }
        }
      },
    },
    mounted() {
      const that = this;
      axios.post('/api/deleted', {}).then(function(response) {
        console.log(response.data);
        let imageNames = response.data.images;
        that.coding = response.data.coding;
        that.space = response.data.space;
        that.catNames = response.data.names;
        that.allCards = imageNames.map(function(name) {
          return {name: name, design: that.coding[name], show: true};
        });
        that.flags = response.data.flags;
      });
    }
  };
</script>